class Gtm {
    datalayerPush(event: string, data?: Record<string, unknown>) {
        if (window && window.dataLayer)
            window.dataLayer.push({ ...data, event });
    }
}

export default Gtm;
